import React from 'react';

import { Box, Card, CircularProgress, Typography } from '@mui/material';

import { useThemeContext } from 'global/ThemeContext/ThemeContext';

type Props = {
  score: number | null;
  loading: boolean;
  progress: number;
};

const ScoreCard: React.FC<Props> = ({ score, loading, progress = 0 }) => {
  const theme = useThemeContext();

  return (
    <Card
      sx={{
        p: 2,
        width: '100%',
        maxHeight: 220,
        background: `${theme.primary}60`,
        border: `1px solid ${theme.primary}`,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        height={48}
        paddingTop={1}
      >
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <Typography variant="h4" color="primary" fontWeight="bold">
            {score !== null && score > 0 ? `${score}º` : '--'}
          </Typography>
        )}
        <Typography variant="body1" color="text.primary" gutterBottom>
          Pontuação
        </Typography>
        {/* <Progress
          percent={progress || 0}
          showInfo={false}
          strokeColor={theme.primary}
          trailColor={theme.background.primary}
          size={{ height: 8 }}
        /> */}
      </Box>
    </Card>
  );
};

export default ScoreCard;
